import {
  Autocomplete,
  Button,
  Checkbox,
  Chip,
  IconButton,
  Paper,
  TextField,
} from "@mui/material";
import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import axios from "axios";
import CustomAlert from "../AlertComponent/Alert";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CloseIcon from "@mui/icons-material/Close";
import { baseURL } from "../../api";
import { Global_Data } from "../../globalData/GlobalData";
import { serverAddress } from "../../config";
import { vsprintf } from "sprintf-js";
import { Icon } from "../../utils/MuiIcons/Icon";
import ComponentLoadingBoundary from "../Loading/ComponentLoadingBoundary";
import usePendingRequests from "../Loading/usePendingRequests";

const AutoCompleteComponent = ({
  data,
  autovaluedata,
  autoValue,
  autoSelectObj,
  rowsdataFree,
  setselectedAUTOCOMPLETE,
  Automod,
  formaction,
  errors,
  setallAccountData,
  isDisabledTable,
  handleClickOpen,
  isSubmited,
  formIsSubmited,
  id,
  textValue1,
  selectAndAutocompleteSname,
  summary,
  mainData,
  helperTextHeight,
  handleItemClear,
  rowScoped,
  resetSignal,
  emptyHelperText = " ",
}) => {
  const {
    token,
    setShippingId,
    textValue,
    setTextValue,
    autoCompleteData,
    setAutoCompleteData,
    freeFormToDefault,
    setFreeFormToDefault,
    setDefaultTableSelectedLocation,
    setDefaultTableSelectedSupplier,
    setGlobalDefaultAutoValueData,
    setGlobalFreeFormAutoValueData,
  } = Global_Data();

  const fieldName = data?.component?.sName;
  const valueField = data?.data?.sValueField || fieldName;
  const isMultiValue = data?.component?.options?.mode === "MULTIVALUE";
  const isFixedOptions =
    data?.component?.options?.mode === "MULTIVALUE" &&
    data?.component?.options?.submode === "FIXEDOPTIONS";

  const [autoValueData, setAutoValueData] = useState([]);
  const [auto, setAuto] = useState(isMultiValue ? [] : null);
  const [editauto, setEditauto] = useState(isMultiValue ? [] : null);
  const [autoMul, setAutoMul] = useState([]);
  const [fixedOptions, setFixedOptions] = useState([]);
  const [valueForFixed, setValueForFixed] = useState([]);
  const [valuePopulated, setValuePopulated] = useState(false);
  const [customError, setCustomError] = useState("");
  useEffect(() => {
    if (!customError) return;
    CustomAlert("error", customError, { domain: "autocomplete", action: "load-options" });
    setCustomError("");
  }, [customError]);
  const [isFocused, setIsFocused] = useState(false);
  const [activityBTN, setActivityBTN] = useState(false);
  const { loading, trackRequest } = usePendingRequests();

  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;
  const lastAwareValueRef = useRef();
  const lastAutoRef = useRef();
  const optionsRequestSequenceRef = useRef(0);

  const removeBorder =
    data?.component?.options?.textFieldProps?.removeBorder || false;

  const getFieldValue = () => {
    const fromTextValue1 = textValue1?.[fieldName];
    const fromTextValue = textValue?.[fieldName];
    const fromDefault = data?.component?.sDefaultValue;

    if (fromTextValue1 !== undefined && fromTextValue1 !== null && fromTextValue1 !== "") {
      return fromTextValue1;
    }

    if (rowScoped) {
      return fromDefault !== undefined && fromDefault !== null
        ? fromDefault
        : "";
    }

    if (fromTextValue !== undefined && fromTextValue !== null && fromTextValue !== "") {
      return fromTextValue;
    }

    if (fromDefault !== undefined && fromDefault !== null && fromDefault !== "") {
      return fromDefault;
    }

    return "";
  };

  const replaceUriParams = (source = {}, uri = "") => {
    let nextUri = uri;

    Object.keys(source || {}).forEach(key => {
      const value = source[key];

      if (value !== undefined && value !== null && String(value).trim() !== "") {
        nextUri = nextUri?.replace(new RegExp(`{${key}}`, "g"), value);
      }
    });

    return nextUri;
  };

  const replacePlaceholders = (uri = "", source = {}) => {
    return uri?.replace(/\{([^}]+)\}/g, (match, key) => {
      const value = source?.[key];

      return Object.prototype.hasOwnProperty.call(source, key) &&
        value !== undefined &&
        value !== null &&
        String(value).trim() !== ""
        ? value
        : match;
    });
  };

  const getOptionDisplay = option => {
    if (!option || option === "" || Object.keys(option || {}).length === 0) {
      return "";
    }

    try {
      return vsprintf(
        data?.data?.sDisplayFormat || "%s",
        replacePlaceholders(data?.data?.sDisplayField || "", option)
          ?.replace(/[{}]/g, "")
          ?.split(",")
      );
    } catch {
      return option?.[valueField] || "";
    }
  };

  const normalizeResponseData = result => {
    return result?.data?.data?.records
      ? result.data.data.records
      : result?.data?.data
      ? result.data.data
      : result?.data || [];
  };

  const setSelectedObject = selectedObject => {
    if (!selectedObject) return;

    if (isMultiValue) {
      const selectedArray = Array.isArray(selectedObject)
        ? selectedObject
        : [selectedObject];

      setAutoMul(selectedArray);
      setAuto(selectedArray);
      setEditauto(selectedArray);
      setFixedOptions(selectedArray);
      setValueForFixed(selectedArray);
      return;
    }

    setAuto(selectedObject);
    setEditauto(selectedObject);
    setAutoMul([selectedObject]);
    setFixedOptions([selectedObject]);
    setValueForFixed([selectedObject]);
  };

  const sendValueToForm = selectedObject => {
    if (!selectedObject) return;

    if (isMultiValue) {
      const value = selectedObject
        .map(item => item?.[valueField])
        .filter(Boolean)
        .join(",");

      autovaluedata(
        {
          target: {
            name: fieldName,
            value,
          },
        },
        selectedObject
      );

      return;
    }

    autovaluedata(
      {
        target: {
          name: fieldName,
          value: selectedObject?.[valueField] || "",
        },
      },
      selectedObject
    );
  };

  const clearValue = () => {
    const emptyValue = isMultiValue ? [] : null;

    setAuto(emptyValue);
    setEditauto(emptyValue);
    setAutoMul([]);
    setValuePopulated(true);

    autovaluedata(
      {
        target: {
          name: fieldName,
          value: "",
        },
      },
      null
    );

    if (setselectedAUTOCOMPLETE) {
      setselectedAUTOCOMPLETE({});
    }

    if (handleItemClear) {
      handleItemClear(textValue1?.id);
    }

    setTimeout(() => {
      setValuePopulated(false);
    }, 0);
  };

  useEffect(() => {
    if (!autoValue) return;

    const requestId = ++optionsRequestSequenceRef.current;

    const rawUri = autoValue?.startsWith("/")
      ? `${baseURL}${autoValue}`
      : `${baseURL}/${replacePlaceholders(autoValue, textValue)}`;

    const uri = replaceUriParams(textValue, rawUri);

    if (/\{[^}]+\}/.test(uri)) return;

    const cached = autoCompleteData?.find(field => field.uri === uri);

    if (cached) {
      setAutoValueData(cached.data);
      return;
    }

    trackRequest(() =>
      axios.get(uri, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
    )
      .then(result => {
        if (requestId !== optionsRequestSequenceRef.current) return;

        const newData = normalizeResponseData(result);

        if (setallAccountData) {
          setallAccountData(newData);
        }

        setAutoValueData(newData);

        setAutoCompleteData(prev =>
          prev.some(item => item.uri === uri)
            ? prev
            : [...prev, { uri, data: newData }]
        );
      })
      .catch(() => {
        if (requestId !== optionsRequestSequenceRef.current) return;
        setCustomError("Something went Wrong");
      });

    return () => {
      if (requestId === optionsRequestSequenceRef.current) {
        optionsRequestSequenceRef.current += 1;
      }
    };
  }, [
    autoValue,
    autoCompleteData,
    isSubmited,
    formIsSubmited,
    token,
    textValue?.[data?.data?.sDataAware?.replace(/[{}]/g, "")],
  ]);

  useEffect(() => {
    if (data?.data?.sAction !== "CASCADE") return;

    const awareField = data?.data?.sDataAware?.replace(/[{}]/g, "");
    const currentAwareValue = textValue?.[awareField];

    if (lastAwareValueRef.current === currentAwareValue) return;

    lastAwareValueRef.current = currentAwareValue;

    if (!fieldName) return;

    setTextValue(prev => {
      if (prev?.[fieldName] === "") return prev;

      return {
        ...prev,
        [fieldName]: "",
      };
    });
  }, [
    data?.data?.sAction,
    data?.data?.sDataAware,
    fieldName,
    textValue?.[data?.data?.sDataAware?.replace(/[{}]/g, "")],
  ]);

  useEffect(() => {
    if (freeFormToDefault) {
      setAuto(isMultiValue ? [] : null);
      setEditauto(isMultiValue ? [] : null);
      setAutoMul([]);
      setFreeFormToDefault(false);
    }
  }, [freeFormToDefault, isMultiValue]);

  useEffect(() => {
    if (!resetSignal) return;

    setAuto(isMultiValue ? [] : null);
    setEditauto(isMultiValue ? [] : null);
    setAutoMul([]);
    setValuePopulated(false);
  }, [resetSignal, isMultiValue]);

  useEffect(() => {
    const selectedLocationField =
      data?.component?.options?.sSelectedLocationField ||
      data?.data?.sSelectedLocationField;

    const shippingField =
      data?.component?.options?.sShippingField ||
      data?.data?.sShippingField;

    if (selectedLocationField && auto?.[selectedLocationField]) {
      setDefaultTableSelectedLocation(auto[selectedLocationField]);
    }

    if (shippingField && auto?.[shippingField]) {
      setShippingId(auto[shippingField]);
    }
  }, [auto]);

  useEffect(() => {
    if (!Array.isArray(autoValueData) || autoValueData.length === 0) return;
    if (valuePopulated) return;

    const savedValue = getFieldValue();

    if (savedValue === "" || savedValue === undefined || savedValue === null) {
      return;
    }

    if (isMultiValue) {
      const selectedIds = String(savedValue)
        .split(",")
        .map(item => item.trim())
        .filter(Boolean);

      const selectedObjects = autoValueData.filter(item =>
        selectedIds.includes(String(item?.[valueField]))
      );

      setSelectedObject(selectedObjects);
      return;
    }

    const selectedObject = autoValueData.find(
      item => String(item?.[valueField]) === String(savedValue)
    );

    if (!selectedObject) return;

    setSelectedObject(selectedObject);

    if (
      data?.component?.sDefaultValue &&
      String(savedValue) === String(data.component.sDefaultValue)
    ) {
      sendValueToForm(selectedObject);
    }
  }, [
    autoValueData,
    valuePopulated,
    fieldName,
    valueField,
    textValue1?.[fieldName],
    textValue?.[fieldName],
    data?.component?.sDefaultValue,
    isMultiValue,
  ]);

  useEffect(() => {
    if (!Array.isArray(autoValueData) || autoValueData.length === 0) return;
    if (!rowsdataFree) return;

    const rowItem = autoValueData.find(
      item => String(item?.[valueField]) === String(rowsdataFree)
    );

    if (rowItem) {
      setEditauto(rowItem);
    }
  }, [autoValueData, rowsdataFree, valueField]);

  useEffect(() => {
    if (!fieldName) return;

    const currentValue =
      textValue1?.[fieldName] ??
      (rowScoped ? undefined : textValue?.[fieldName]) ??
      data?.component?.sDefaultValue ??
      "";

    if (currentValue !== "") return;

    const emptyValue = isMultiValue ? [] : null;

    setAuto(emptyValue);
    setEditauto(emptyValue);
    setAutoMul([]);
  }, [
    id,
    fieldName,
    isMultiValue,
    textValue1?.[fieldName],
    textValue?.[fieldName],
    data?.component?.sDefaultValue,
    rowScoped,
  ]);

  useEffect(() => {
    if (isSubmited) {
      setAutoMul([]);
    }
  }, [isSubmited]);

  useEffect(() => {
    if (data?.data?.bGlobalDefaultAutoValueData !== 1) return;

    setGlobalDefaultAutoValueData(autoValueData);
    setGlobalFreeFormAutoValueData(autoValueData);
  }, [autoValueData, data?.data?.bGlobalDefaultAutoValueData]);

  useLayoutEffect(() => {
    if (!autoSelectObj) return;

    const current = JSON.stringify(auto);

    if (lastAutoRef.current === current) return;

    lastAutoRef.current = current;
    autoSelectObj(auto);
  }, [auto, autoSelectObj]);

  useEffect(() => {
    if (!data?.data?.sAdd?.sFormName || !data?.data?.sAdd?.sAction) return;

    const urlCapture =
      serverAddress +
      `/form/isallowed/transaction?module=${data.data.sAdd.sFormName}&activity=${data.data.sAdd.sAction}`;

    trackRequest(() =>
      axios.get(urlCapture, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
    )
      .then(result => {
        setActivityBTN(result.data.data.Access !== "No");
      })
      .catch(error => {
        console.error(error, "error456");
      });
  }, [data?.data?.sAdd?.sFormName, data?.data?.sAdd?.sAction, token]);

  const onTagsChange = (event, values) => {
    if (!values) {
      clearValue();
      return;
    }

    if (data?.component?.options?.bSetDefaultTableSelectedSupplier === true) {
      setDefaultTableSelectedSupplier(values?.[valueField]);
    }

    const selectedLocationField =
      data?.component?.options?.sSelectedLocationField ||
      data?.data?.sSelectedLocationField;

    if (selectedLocationField && values?.hasOwnProperty(selectedLocationField)) {
      setDefaultTableSelectedLocation(values[selectedLocationField]);
    }

    setSelectedObject(values);

    if (setselectedAUTOCOMPLETE) {
      setselectedAUTOCOMPLETE(values);
    }

    sendValueToForm(values);
  };

  const onFixedChange = (event, values) => {
    setValueForFixed([
      ...fixedOptions,
      ...values?.filter(option => fixedOptions.indexOf(option) === -1),
    ]);
  };

  const openModalforGroupAdd = data => {
    const mode = {
      options: {
        mode: "DEFAULT",
        handler: "handleDialog",
        dialog: data.data.sAdd.sAddForm,
        sDataSource: data.data.sDataSource,
        nested: true,
      },
    };

    handleClickOpen(mode);
    selectAndAutocompleteSname({
      name: data.component.sName,
      value: data?.data?.sValueField,
    });
  };

  const handleKeyDown = event => {
    if (event.key === "ArrowUp" || event.key === "ArrowDown") {
      event.stopPropagation();
    }

    if (event.key === "Backspace" || event.key === "Delete") {
      setValuePopulated(true);
      return;
    }

    if (valuePopulated) {
      setValuePopulated(false);
    }
  };

  const renderAddButtonPaper = ({ children }) => (
    <Paper>
      {data?.data?.sAdd?.sAction === "ADD" && (
        <Button
          color="primary"
          fullWidth
          {...data?.data?.sAdd?.sMessageProps}
          onMouseDown={() => openModalforGroupAdd(data)}
          disabled={!activityBTN}
        >
          <Icon
            iconName={data?.data?.sAdd?.sAddIcon}
            sProps={data?.data?.sAdd?.sIconProps}
          />
          {data?.data?.sAdd?.sAddMessage}
        </Button>
      )}
      {children}
    </Paper>
  );

  const renderOption = (props, option, { selected }) => {
    if (isMultiValue && data?.component?.options?.submode === "CHECKBOXES") {
      return (
        <li {...props}>
          <Checkbox
            icon={icon}
            checkedIcon={checkedIcon}
            style={{ marginRight: 8 }}
            checked={selected}
          />
          <span
            dangerouslySetInnerHTML={{
              __html: getOptionDisplay(option),
            }}
          />
        </li>
      );
    }

    return (
      <li {...props}>
        <span
          dangerouslySetInnerHTML={{
            __html: getOptionDisplay(option),
          }}
        />
      </li>
    );
  };

  const renderInput = params => {
    const { inputProps, ...restParam } = params;
    const {
      onKeyDown: originalOnKeyDown,
      value: inputValueFromParams,
      ...restInputProps
    } = inputProps || {};

    const wrappedInputProps = {
      ...restInputProps,
      value:
        typeof inputValueFromParams === "string"
          ? inputValueFromParams.replace(/<[^>]+>/g, "")
          : inputValueFromParams,
      onKeyDown: e => {
        if (typeof originalOnKeyDown === "function") {
          originalOnKeyDown(e);
        }

        const key = e.key || "";
        const code = e.code || "";
        if (key === " " || key === "Spacebar" || code === "Space") {
          e.stopPropagation();
        }
      },
    };

    return (
      <TextField
        {...restParam}
        inputProps={wrappedInputProps}
        id={fieldName}
        name={fieldName}
        size="medium"
        label={data?.component?.sLabel}
        placeholder={data?.component?.sPlaceHolder}
        disabled={isDisabledTable || data?.component?.sProps?.disabled}
        helperText={
          helperTextHeight
            ? !isFocused && (errors || data?.component?.sHelper)
            : isFocused
              ? emptyHelperText
              : (!isFocused && (errors || data?.component?.sHelper)) ||
                emptyHelperText
        }
        error={!isFocused && Boolean(errors)}
        sx={
          removeBorder
            ? {
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    border: "none",
                  },
                },
                "& .MuiInputBase-root": {
                  padding: "0px",
                },
              }
            : {}
        }
        {...data?.component?.options?.textFieldProps}
      />
    );
  };

  const commonAutocompleteProps = {
    options: autoValueData || [],
    getOptionLabel: getOptionDisplay,
    isOptionEqualToValue: (option, value) =>
      String(option?.[valueField]) === String(value?.[valueField]),
    onChange: onTagsChange,
    onKeyDown: handleKeyDown,
    onFocus: () => setIsFocused(true),
    onBlur: () => setIsFocused(false),
    PaperComponent: renderAddButtonPaper,
    renderOption,
    renderInput,
    disabled: isDisabledTable || data?.component?.sProps?.disabled,
    disableCloseOnSelect:
      isMultiValue && data?.component?.options?.submode === "CHECKBOXES",
  };

  const currentValue = isMultiValue ? autoMul : auto || null;

  return (
    <ComponentLoadingBoundary
      loading={loading}
      label={`Loading ${data?.component?.sLabel || fieldName}`}
      minHeight={40}
      size={20}
    >

      {formaction === undefined || formaction === "" || formaction === "ADD" ? (
        isFixedOptions ? (
          <Autocomplete
            {...data?.component?.sProps}
            {...commonAutocompleteProps}
            multiple
            id={fieldName}
            name={fieldName}
            value={valueForFixed}
            onChange={onFixedChange}
            renderTags={(tagValue, getTagProps) =>
              tagValue?.map((option, index) => (
                <Chip
                  key={index}
                  label={getOptionDisplay(option)}
                  {...getTagProps({ index })}
                  disabled={fixedOptions.indexOf(option) !== -1}
                />
              ))
            }
          />
        ) : (
          <Autocomplete
            {...data?.component?.sProps}
            {...commonAutocompleteProps}
            multiple={isMultiValue}
            id={
              summary
                ? `${mainData}-${summary}`
                : textValue1?.id
                  ? `${fieldName}-${textValue1.id}`
                  : id
                    ? `${fieldName}-${id}`
                    : fieldName
            }
            name={fieldName}
            groupBy={
              data?.data?.sGroupField
                ? option => option?.[data?.data?.sGroupField]
                : undefined
            }
            value={currentValue}
            clearIcon={
              <IconButton
                onClick={() => {
                  clearValue();
                }}
              >
                <CloseIcon />
              </IconButton>
            }
          />
        )
      ) : null}

      {formaction === "EDIT" && (
        <Autocomplete
          {...data?.component?.sProps}
          {...commonAutocompleteProps}
          multiple={isMultiValue}
          id={fieldName}
          name={fieldName}
          value={editauto || (isMultiValue ? [] : null)}
          filterSelectedOptions
          clearIcon={
            <IconButton
              onClick={() => {
                clearValue();
              }}
            >
              <CloseIcon />
            </IconButton>
          }
        />
      )}
    </ComponentLoadingBoundary>
  );
};

export default AutoCompleteComponent;
